<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g fill="none" fill-rule="evenodd">
    <circle cx="12" cy="12" r="11" [attr.stroke]="inverse ? '#FFFFFF' : color" stroke-width="2"/>
    <circle cx="12" cy="16" r="1" [attr.fill]="inverse ? '#FFFFFF' : color" [attr.stroke]="inverse ? '#FFFFFF' : color"/>
    <path [attr.fill]="inverse ? '#FFFFFF' : color" d="M13 13l.5-7c-.331-.667-.831-1-1.5-1s-1.169.333-1.5 1l.5 7h2z"/>
  </g>
</svg>
